/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Pedal_Action_PauseInputs */



/**
* | output |
* | --- |
* | "Pause" |
*
* @param {Options_Pedal_Action_PauseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_pedal_action_pause = /** @type {((inputs?: Options_Pedal_Action_PauseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Pedal_Action_PauseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pause")
	if (locale === "de") return /** @type {LocalizedString} */ ("Pause")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pausa")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пауза")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pausa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("暂停")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一時停止")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विराम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pausa")
	return /** @type {LocalizedString} */ ("Pause")
});